import { useSelector } from "react-redux";

import ReadJS from "../../../../components/analytics/ReadJS";
import StoryBody from "../../../../components/StoryBody/component";

import { hasLeadMediaClipID } from "../../../../utils/content/library";
import { concatSubjects } from "../../../../utils/dataTransform/ContentItem/library";
import { isMobileDevice } from "../../../../utils/user-agent/library";
import { MOBILE_AD_INDEX_ARRAY, DESKTOP_AD_INDEX_ARRAY } from "../../constants";
import { isServer } from "../../../../utils/environmentDetection/library";

const StoryBodyDetail = ({ noAds }) => {
    const { pageType, path, baseSection, contentId, section } = useSelector(
        (state) => state.app
    );
    const content = useSelector((state) => state.detail.content);
    const leadVideoOrAudio = useSelector(
        (state) => state.detail.leadVideoOrAudio
    );
    const leadSegmentOrEpisodeAudio = useSelector(
        (state) => state.detail.leadSegmentOrEpisodeAudio
    );
    const featureflags = useSelector((state) => state.featureflags);

    const storyBody = content.body;
    const isSponsoredContent = content.type === "sponsoredcontent";

    const adProps = {
        pageType: pageType,
        pagePath: path,
        pageSection: baseSection,
        contentId: contentId,
        exclusions: content.adExclusions,
        targeting: {
            subject: concatSubjects(content.subject),
            gs_categories: content.gs_categories,
            gs_keywords: content.gs_keywords,
        },
    };

    const storyAdIndex = () => {
        if (isMobileDevice() || window.innerWidth <= 1100) {
            return MOBILE_AD_INDEX_ARRAY;
        }

        return DESKTOP_AD_INDEX_ARRAY;
    };

    if (noAds) {
        return (
            <StoryBody
                body={storyBody}
                hasLeadMediaClipID={hasLeadMediaClipID(
                    leadVideoOrAudio,
                    leadSegmentOrEpisodeAudio
                )}
                isSponsoredContent={isSponsoredContent}
            />
        );
    }

    return (
        <ReadJS
            url={content.url}
            type={content.type}
            id={content.id}
            headline={content.headline}
            pubdate={content.publishedAt}
        >
            <StoryBody
                section={section}
                featureflags={featureflags}
                content={content}
                body={storyBody}
                adData={adProps}
                hasLeadMediaClipID={hasLeadMediaClipID(
                    leadVideoOrAudio,
                    leadSegmentOrEpisodeAudio
                )}
                adIndexArray={isServer() ? null : storyAdIndex()}
                isSponsoredContent={isSponsoredContent}
            />
        </ReadJS>
    );
};

export default StoryBodyDetail;
